import { CommonModule } from "@angular/common";
import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { PopupCloseMode } from "@features/control-points/models/popupMode";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CurrentStateService } from "app/core/services/current-state.service";
import { Subject, takeUntil } from "rxjs";
import { SitesAreaService } from "../../services/sites-area.service";
import { RegionData } from "@shared/models/region-data";
import { Organization } from "@shared/models/organization";
import { FonctionsService } from "@shared/services/utilities/fonctions.service";

@Component({
  selector: 'app-popup-area',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgSelectComponent
  ],
  templateUrl: './area-modal.component.html',
  styleUrl: './area-modal.component.scss'
})

export class AreaModaleComponent implements OnInit {
  @ViewChild('popup') popup!: ElementRef;
  @Output() close = new EventEmitter<PopupCloseMode>();
  private unsubscribe$ = new Subject<void>();
  protected isNew: boolean = false;
  selectedRegion: RegionData;
  organizations: Organization[] = [];
  protected form: FormGroup | undefined;
  constructor(
    protected currentStateService: CurrentStateService,
    private dialog: MatDialog,
    private sitesAreaService: SitesAreaService,
    private fonctionsService: FonctionsService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
        this.form = new FormGroup({
        name: new FormControl(null, [Validators.required]),
        organization: new FormControl(null, [Validators.required]),
        regionId: new FormControl(null),
      });
      

    this.currentStateService.closePopup$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (closeMode: PopupCloseMode | null) => {
        if (closeMode != null && closeMode === PopupCloseMode.CLOSE) {
          this.onClose(closeMode);
        }
      }
    });
  }
    ngOnInit(): void {
        this.isNew = this.data?.isNew;
        this.organizations = this.data?.organizations;
        this.selectedRegion = this.data?.region;
        if (this.selectedRegion) {
            this.form.reset();
            this.patchFormFromSelectedRegion();
          }
    }
    private patchFormFromSelectedRegion(): void {
        if (this.selectedRegion) {
          this.form.patchValue({
            name: this.selectedRegion.name || null,
            organization: this.selectedRegion.orgId || null,
            regionId: this.selectedRegion.regionId || null,
          });
        }
      }
      

  protected onClose(closeMode: PopupCloseMode = PopupCloseMode.CLOSE) {
    this.close.emit(closeMode);
    this.dialog.closeAll();
  }
  onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
        return;
    }
    if (this.isNew) {
        this.sitesAreaService.createArea(this.getRegionDataFromForm()).subscribe({
            next: () => {
                this.onClose(PopupCloseMode.CLOSE);
                this.fonctionsService.launch_toast(true, this.translate.instant('SUCCESS.AREA_SAVED'));
            },
            error: () => {
                this.fonctionsService.launch_toast(true, this.translate.instant('ERRORS.FAILED_TO_SAVE_AREA'));
            }
        });
    } else {
        this.sitesAreaService.updateArea(this.getRegionDataFromForm()).subscribe({
            next: () => {
                this.onClose(PopupCloseMode.CLOSE);
                this.fonctionsService.launch_toast(true, this.translate.instant('SUCCESS.AREA_SAVED'));
            },
            error: () => {
                this.fonctionsService.launch_toast(true, this.translate.instant('ERRORS.FAILED_TO_SAVE_AREA'));
            }
        });
    }
}
  getRegionDataFromForm(): any {
    const formValue = this.form.value;
    const regionData = {
      regionId: formValue.regionId,
      orgId: formValue.organization,
      nom: formValue.name,
      isActif: true,
      nbSites: this.selectedRegion?.nbSites || 0,
      nbUsers: this.selectedRegion?.nbUsers || 0,
      orgName: this.organizations.find(org => org.orgId === formValue.organization)?.name || '',
    };
    
    return regionData;
  }
}